module.exports = __webpack_public_path__ + "static/media/gallery-12.850e2bbd.jpg";